<script>
  // @ts-check

  import Icon from "../atoms/Icon.svelte";
  import Link from "../atoms/Link.svelte";
  import { getTheme } from "../utilities";
  import { createEventDispatcher } from "svelte";

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;
  export let title = "";
  export let body = "";

  /**
   * optional if a "cta" slot is used instead.
   *
   * @type {import('../types/shared.js').CTA}
   */
  export let cta = undefined;

  /** @type {"top" | "bottom"}*/
  export let variant = "top";

  /** @type {import("../utilities/themes").ThemeName}*/
  export let themeName;
  $: currentTheme = getTheme(themeName ?? "lightBlue");

  export let isHidden = false;
  const dispatch = createEventDispatcher();
  const closeBanner = () => {
    if (variant === "bottom") {
      isHidden = true;
      dispatch("close");
    }
  };

  const compact = !body && !cta;
  $: position = variant === "top" ? "relative" : "fixed bottom-0";
</script>

{#if variant === "top" || !isHidden}
  <div
    {id}
    class="{position} {currentTheme.backgroundColor} {currentTheme.textColor} {variant === 'top'
      ? 'z-[--stack-level-top-banner]'
      : 'z-[--stack-level-bottom-banner]'}  w-full"
    role={variant === "top" ? "alert" : "dialog"}
    aria-labelledby="banner-title"
    aria-describedby="banner-body"
  >
    <div
      class="mx-auto flex max-w-container-content-max flex-col justify-start gap-5 px-[30px] py-5 md:flex-row md:justify-between lg:gap-[30px] lg:px-15 lg:py-10"
      class:!justify-center={compact}
    >
      <div class="flex flex-col gap-5">
        <div
          id="banner-title"
          class="heading-xs"
          class:text-center={compact}
          class:mr-5={variant === "bottom"}
        >
          {title}
        </div>

        {#if body}
          <div
            id="banner-body"
            class="body-sm sm:block md:block"
            class:sm:hidden={variant === "bottom"}
          >
            {body}
          </div>
        {/if}
      </div>

      {#if cta || $$slots.cta}
        <div
          class="flex-none self-start md:self-end"
          class:md:!self-center={variant === "bottom" && !body}
          class:md:mr-10={variant === "bottom" && !body}
        >
          <slot name="cta">
            <Link
              id={cta.id}
              class="flex flex-row {currentTheme.textColor}"
              variant="small"
              label={cta.text}
              href={cta.url}
              isExternal={cta.isExternal}
              on:click={closeBanner}
              on:keypress={closeBanner}
            />
          </slot>
        </div>
      {/if}

      {#if variant === "bottom"}
        <div class="absolute right-5 lg:right-15">
          <Link
            id="banner-close-btn"
            variant="inline"
            class={currentTheme.textColor}
            aria-label="Close dialog"
            on:click={closeBanner}
            on:keypress={closeBanner}
          >
            <Icon name="close" />
          </Link>
        </div>
      {/if}
    </div>
  </div>
{/if}
